import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const CyclingIcon = observer('CyclingIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='cyclingMask'
                width='16'
                height='15'
                x='0'
                y='0'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M3.333 14.183a3.21 3.21 0 0 1-2.358-.975A3.21 3.21 0 0 1 0 10.85q0-1.383.975-2.358a3.21 3.21 0 0 1 2.358-.975q1.384 0 2.359.975t.975 2.358-.975 2.358-2.359.975m0-1.333q.834 0 1.417-.583.583-.584.583-1.417T4.75 9.433a1.93 1.93 0 0 0-1.417-.583q-.833 0-1.416.583a1.93 1.93 0 0 0-.584 1.417q0 .834.584 1.417.583.583 1.416.583m4-.667V8.85L5.2 6.983a1.2 1.2 0 0 1-.3-.425q-.1-.24-.1-.508 0-.267.108-.508.11-.242.292-.425L7.067 3.25q.2-.2.458-.3t.542-.1.541.1.459.3l1.266 1.267q.467.465 1.067.733t1.267.267V6.85a4.6 4.6 0 0 1-1.809-.367A4.8 4.8 0 0 1 9.333 5.45L8.8 4.917l-1.6 1.6L8.667 8.05v4.133zm3-9q-.55 0-.941-.391A1.28 1.28 0 0 1 9 1.85q0-.55.392-.942.391-.39.941-.391.55 0 .942.391t.392.942-.392.942a1.28 1.28 0 0 1-.942.391m2.334 11a3.21 3.21 0 0 1-2.359-.975 3.21 3.21 0 0 1-.975-2.358q0-1.383.975-2.358a3.21 3.21 0 0 1 2.359-.975q1.383 0 2.358.975T16 10.85t-.975 2.358-2.358.975m0-1.333q.832 0 1.416-.583.585-.584.584-1.417 0-.834-.584-1.417a1.93 1.93 0 0 0-1.416-.583q-.834 0-1.417.583a1.93 1.93 0 0 0-.583 1.417q0 .834.583 1.417t1.417.583'
                />
            </mask>
            <g mask='url(#cyclingMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
